<script>
export const group = 'Bottom'
export const reuseComponent = true
</script>

<script setup>
import { onMounted, ref } from 'vue'
import { cdnImageUrl } from '@dpgradio/creative'
import { colors } from '../../../tailwindTheme.config.js'
import EFLoopAudioLevels02 from '../../../assets/animations/energetic_frequencies/loops/audio_levels_02.json'
import ContentBar from './shared/ContentBar.vue'
const gsapTimeline = useGsapTimeline()

defineProps({
  item: Object,
})

const colorScheme = { backgroundColor: colors.q.cr.gray.primary, color: colors.q.cr.gray.darker }

const timelineContentBar = ref(null)
const timelineContentBarOut = ref(null)

const aiElement = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'CurrentArtistFactSmall' })
    .add(timelineContentBar)
    .from(aiElement.value, { scale: 0, opacity: 0, duration: frames(4) }, `<${frames(6)}`)
})

const { onDisappear } = useDisappearable()
onDisappear(() =>
  gsapTimeline({ name: 'CurrentArtistFactSmall - End' })
    .add(timelineContentBarOut.value())
    .to(aiElement.value, { scale: 0, opacity: 0, duration: frames(4) }, `<${frames(12)}`)
)
</script>

<template>
  <div ref="aiElement" class="bg-q-cr-gray-darker text-2xl rounded-full absolute bottom-12 px-4 py-1 left-[63%] z-20 font-bold text-white">✨ Informatie met hulp van AI</div>
  <ContentBar
    :title="item.enrichment.track.artist.name"
    :body="item.enrichment.fact?.body"
    :image="cdnImageUrl(item.enrichment.track.artist.images?.default)"
    :colorScheme="colorScheme"
    :backgroundAnimation="EFLoopAudioLevels02"
    @timeline="timelineContentBar = $event"
    @timelineOut="timelineContentBarOut = $event"
  />
</template>
